module.exports = __webpack_public_path__ + "static/media/icon-sucursal.558df771.svg";